'use es6';

import { defaultMemoize } from 'reselect';
import getIn from 'transmute/getIn';
export const getIndexedAsyncSenders = defaultMemoize(getIn(['threadViewRootReducer', 'senders']));